module.exports = __webpack_public_path__ + "img/password.cf3ffc55.svg";